import { Post } from '../helpers';
import { createPath } from './utils';
import { ResourceRequest } from '@/access/resource-grant';

export function GrantAccess(channel: number, email: string, resources: ResourceRequest[]) {
  return Post<{ message: string }>({
    path: createPath(`${channel}/user`),
    body: {
      email,
      resources,
    },
  });
}
